import { useNavigate } from "react-router";

import FlashContext from "components/FlashMessages/FlashContext";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";
import PermissionGateButton from "components/PermissionGate/Button";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import useCanPerformTaskAgain from "shared/Stack/access/useCanPerformTaskAgain";
import useTaskCreate from "shared/Stack/useTaskCreate";
import { AccessResult } from "utils/access";
import { StackContext } from "views/Stack/Context";
import { StackTaskRun } from "views/Stack/Tasks/gql";

const StackTasksTableActionsCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  const { stack } = useTypedContext(StackContext);
  const { reportSuccess } = useTypedContext(FlashContext);
  const navigate = useNavigate();
  const canPerformTaskAgainFn = useCanPerformTaskAgain();

  const [createTask, { loading }] = useTaskCreate();

  const access = canPerformTaskAgainFn(task, stack);

  //Message can be moved to canPerformTaskAgainFn and this const be removed after stack-tasks-list-redesign feature flag cleanup
  const canPerformAgain: AccessResult =
    access.result || access.message
      ? access
      : //TODO: update access message once design will provide a proper one
        { result: false, message: "This task can't be performed again" };

  const performTaskAgain = () => {
    createTask(
      { stack: stack.id, command: task.command ?? "", skipInitialization: false },
      (data) => {
        if (data?.taskCreate?.id) {
          const taskId = data.taskCreate.id;
          reportSuccess({ message: `Task ${taskId} successfully triggered` });
          navigate(`/stack/${stack.id}/run/${taskId}`);
        }
      }
    );
  };

  return (
    <TableSimpleCell {...cellProps}>
      <PermissionGateButton
        access={canPerformAgain}
        variant="secondary"
        size="small"
        onPress={performTaskAgain}
        loading={loading}
        analyticsPage={AnalyticsPageStack.StacksTaskList}
        analyticsTitle="Perform again clicked"
      >
        Perform again
      </PermissionGateButton>
    </TableSimpleCell>
  );
};

export default StackTasksTableActionsCell;
